import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionTab {
  title: string;
  content: React.ReactNode;
}
function ProductAccordion({
  tabs
}: {
  tabs: AccordionTab[];
}) {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white" data-id="element-264">
      {tabs.map((tab, index) => <div key={index} className={index > 0 ? 'border-t border-gray-200' : ''} data-id="element-265">
          <button onClick={() => setOpenIndex(openIndex === index ? -1 : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-266">
            <span className="font-bold text-[#1A1A1A] text-base" data-id="element-267">
              {tab.title}
            </span>
            <ChevronDown className={`text-[#1B5E20] transition-transform duration-300 shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-268" />
          </button>
          <AnimatePresence data-id="element-269">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-270">
                <div className="px-6 pb-6 text-gray-600 text-[15px] leading-relaxed" data-id="element-271">
                  {tab.content}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}
export function ProductsDetail() {
  const products = [{
    name: 'FLORA LIV',
    subtitle: 'Tu Escudo Probiótico Diario',
    badge: '🌿 Probiótico | Granadilla + Aguaymanto',
    image: 'https://cdn.magicpatterns.com/uploads/8USqkP8zBUgtLPgMUv1AVq/heylloyd-image-1776739580779.png',
    tabs: [{
      title: 'Descripción del producto',
      content: <p data-id="element-272">
              10 mil millones de bacterias probióticas por toma, cuya acción en
              el intestino se potencia con la ayuda de la fibra prebiótica, así
              como las vitaminas y minerales que contiene.
            </p>
    }, {
      title: 'Cómo se toma y sabor',
      content: <div data-id="element-273">
              <p data-id="element-274">Disolver un sobre en un vaso de 180ml de agua.</p>
              <p className="mt-2" data-id="element-275">Consumir diariamente.</p>
              <p className="mt-2 font-medium text-[#1A1A1A]" data-id="element-276">
                Sabor: Granadilla y Aguaymanto.
              </p>
            </div>
    }, {
      title: 'Beneficios',
      content: <ul className="space-y-3" data-id="element-277">
              <li className="flex items-start" data-id="element-278">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-279">•</span>
                <span data-id="element-280">
                  Regenera y equilibra la flora intestinal, necesaria para la
                  correcta asimilación de los nutrientes y protección
                  inmunológica del organismo
                </span>
              </li>
              <li className="flex items-start" data-id="element-281">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-282">•</span>
                <span data-id="element-283">Previene y alivia trastornos digestivos</span>
              </li>
              <li className="flex items-start" data-id="element-284">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-285">•</span>
                <span data-id="element-286">
                  Reduce los efectos nocivos del uso de medicamentos como los
                  antibióticos que destruyen el ecosistema intestinal
                </span>
              </li>
            </ul>
    }, {
      title: 'Ingredientes',
      content: <p data-id="element-287">
              Fusión Nutracéutica: Cultivos Probióticos + Fibra Prebiótica +
              Extracto de Pulpa de Granadilla + Aguaymanto
            </p>
    }]
  }, {
    name: 'PRUNEX 1',
    subtitle: 'Limpieza y Tránsito Natural',
    badge: '🌾 Fibra Natural | Ciruela + Higo + Anís',
    image: 'https://cdn.magicpatterns.com/uploads/ovPnvd2KMHCSfmKdDq7NSz/heylloyd-image-1776739707609.png',
    tabs: [{
      title: 'Descripción del producto',
      content: <p data-id="element-288">
              Bebida frutal en base a mix de fibras solubles y extracto de
              guindones, los cuales representan una alternativa eficaz en casos
              de estreñimiento, promoviendo la desintoxicación del colon.
            </p>
    }, {
      title: 'Cómo se toma y sabor',
      content: <div data-id="element-289">
              <p data-id="element-290">Disolver un sobre en una taza con agua caliente.</p>
              <p className="mt-2" data-id="element-291">Consumir preferiblemente en las noches.</p>
              <p className="mt-2 font-medium text-[#1A1A1A]" data-id="element-292">
                Sabor: Ciruela con Anís.
              </p>
            </div>
    }, {
      title: 'Beneficios',
      content: <ul className="space-y-3" data-id="element-293">
              <li className="flex items-start" data-id="element-294">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-295">•</span>
                <span data-id="element-296">
                  Estimula la actividad del colon gracias a su efecto laxante
                  natural
                </span>
              </li>
              <li className="flex items-start" data-id="element-297">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-298">•</span>
                <span data-id="element-299">
                  Promueve un adecuado tránsito intestinal y evita la
                  indigestión luego de comidas pesadas o abundantes
                </span>
              </li>
              <li className="flex items-start" data-id="element-300">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-301">•</span>
                <span data-id="element-302">Desintoxica el colon de forma natural y efectiva</span>
              </li>
            </ul>
    }, {
      title: 'Ingredientes',
      content: <p data-id="element-303">
              Fusión Nutracéutica: Mix de Fibras (Psyllium, Inulina de
              Achicoria, Mucílago de Linaza), Kelp, Anís Estrella, Extracto de
              Guindones.
            </p>
    }]
  }, {
    name: 'REXET',
    subtitle: 'Detox Hepático y Metabolismo',
    badge: '🫚 Detox | Alcachofa + Cardo Mariano',
    image: 'https://cdn.magicpatterns.com/uploads/dwSH7JNppMmzk5TrceeP3o/heylloyd-image-1776740348623.png',
    tabs: [{
      title: 'Descripción del producto',
      content: <p data-id="element-304">
              Refresco efervescente sabor Tuna Roja que contribuye a proteger tu
              hígado, promoviendo su función desintoxicante y el equilibrio
              metabólico del cuerpo.
            </p>
    }, {
      title: 'Cómo se toma y sabor',
      content: <div data-id="element-305">
              <p data-id="element-306">Disolver un sobre en un vaso de 180ml de agua fría.</p>
              <p className="mt-2" data-id="element-307">Consumir diariamente.</p>
              <p className="mt-2 font-medium text-[#1A1A1A]" data-id="element-308">
                Sabor: Tuna Roja con Limón — refrescante y ligeramente ácido.
              </p>
            </div>
    }, {
      title: 'Beneficios',
      content: <ul className="space-y-3" data-id="element-309">
              <li className="flex items-start" data-id="element-310">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-311">•</span>
                <span data-id="element-312">
                  Mantiene óptimas las funciones metabólicas del hígado
                </span>
              </li>
              <li className="flex items-start" data-id="element-313">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-314">•</span>
                <span data-id="element-315">
                  Mantiene el cuerpo en equilibrio, favoreciendo la eliminación
                  de toxinas
                </span>
              </li>
              <li className="flex items-start" data-id="element-316">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-317">•</span>
                <span data-id="element-318">
                  Promueve la función depurativa desde el sistema digestivo
                </span>
              </li>
            </ul>
    }, {
      title: 'Ingredientes',
      content: <div data-id="element-319">
              <p className="mb-2" data-id="element-320">
                Mix de Extractos Vegetales: Tuna Roja, Hierbaluisa, Clorofila,
                Acerola, Cúrcuma, Perejil, Alcachofa.
              </p>
              <p className="mb-2" data-id="element-321">
                Mix Péptidos y Aminoácidos: Colágeno Hidrolizado, Taurina,
                Cisteína.
              </p>
              <p data-id="element-322">
                Mix de Vitaminas y Minerales: Complejo B (B1, B2, Niacinamida,
                B6, B9, B12), Magnesio, Zinc.
              </p>
            </div>
    }]
  }, {
    name: 'GOLDEN FLX',
    subtitle: 'Anti-inflamatorio y Articulaciones',
    badge: '💛 Cúrcuma | Jengibre + Vainilla',
    image: 'https://cdn.magicpatterns.com/uploads/h79ZzNE5bgweXe8ne3pBMN/heylloyd-image-1776740521871.png',
    tabs: [{
      title: 'Descripción del producto',
      content: <p data-id="element-323">
              Deliciosa bebida inspirada en el tradicional Golden Milk, creada
              por FuXion para mejorar la flexibilidad de las articulaciones,
              desinflamarlas y fortalecerlas desde adentro.
            </p>
    }, {
      title: 'Cómo se toma y sabor',
      content: <div data-id="element-324">
              <p data-id="element-325">Disolver un sobre en una taza de agua caliente.</p>
              <p className="mt-2" data-id="element-326">
                Consumir diariamente, preferiblemente en las mañanas.
              </p>
              <p className="mt-2 font-medium text-[#1A1A1A]" data-id="element-327">
                Sabor: Golden Milk — cúrcuma, jengibre, vainilla y coco. Cálido
                y reconfortante.
              </p>
            </div>
    }, {
      title: 'Beneficios',
      content: <ul className="space-y-3" data-id="element-328">
              <li className="flex items-start" data-id="element-329">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-330">•</span>
                <span data-id="element-331">
                  Mejora la movilidad y flexibilidad de las articulaciones
                </span>
              </li>
              <li className="flex items-start" data-id="element-332">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-333">•</span>
                <span data-id="element-334">Es un poderoso desinflamante natural</span>
              </li>
              <li className="flex items-start" data-id="element-335">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-336">•</span>
                <span data-id="element-337">Mejora la digestión de los principios activos</span>
              </li>
              <li className="flex items-start" data-id="element-338">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-339">•</span>
                <span data-id="element-340">Fortalece articulaciones y tejidos conectivos</span>
              </li>
              <li className="flex items-start" data-id="element-341">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-342">•</span>
                <span data-id="element-343">Acción antioxidante profunda con cúrcuma orgánica</span>
              </li>
            </ul>
    }, {
      title: 'Ingredientes',
      content: <p data-id="element-344">
              Fusión Nutracéutica: Extracto de Cúrcuma Orgánica Certificada y
              Patentada (Turmipure) + Extracto de Jengibre (Kión) + Cardamomo +
              Leche de Coco + Pimienta Negra + Canela.
            </p>
    }]
  }, {
    name: 'YOUTH ELIXIR',
    subtitle: 'Energía, Anti-edad y Antioxidantes',
    badge: '✨ Anti-edad | Açaí + Maqui + Camu Camu',
    image: 'https://cdn.magicpatterns.com/uploads/7EyPWVumWFMBC2oef9uDoi/heylloyd-image-1776741800906.png',
    tabs: [{
      title: 'Descripción del producto',
      content: <p data-id="element-345">
              Deliciosa bebida sabor Uva de Vino, creada por FuXion para
              ayudarte a retardar los síntomas del paso de los años. Aumenta la
              vitalidad, la elasticidad de la piel, la flexibilidad de las
              arterias y mejora la calidad del sueño.
            </p>
    }, {
      title: 'Cómo se toma y sabor',
      content: <div data-id="element-346">
              <p data-id="element-347">Disolver un sobre en un vaso de agua fría.</p>
              <p className="mt-2" data-id="element-348">Consumir preferiblemente en las noches.</p>
              <p className="mt-2 font-medium text-[#1A1A1A]" data-id="element-349">
                Sabor: Uva de Vino — dulce y antioxidante.
              </p>
            </div>
    }, {
      title: 'Beneficios',
      content: <ul className="space-y-3" data-id="element-350">
              <li className="flex items-start" data-id="element-351">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-352">•</span>
                <span data-id="element-353">Retarda los síntomas del envejecimiento celular</span>
              </li>
              <li className="flex items-start" data-id="element-354">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-355">•</span>
                <span data-id="element-356">Aumenta la vitalidad y energía natural</span>
              </li>
              <li className="flex items-start" data-id="element-357">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-358">•</span>
                <span data-id="element-359">
                  Mejora la elasticidad de la piel y flexibilidad de las
                  arterias
                </span>
              </li>
              <li className="flex items-start" data-id="element-360">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-361">•</span>
                <span data-id="element-362">Mejora la calidad del sueño</span>
              </li>
              <li className="flex items-start" data-id="element-363">
                <span className="text-[#4CAF50] mr-3 mt-0.5 font-bold" data-id="element-364">•</span>
                <span data-id="element-365">Poderosa acción antioxidante con superfrutos</span>
              </li>
            </ul>
    }, {
      title: 'Ingredientes',
      content: <p data-id="element-366">
              Fusión Nutracéutica: Mix de Aminoácidos + Resveratrol +
              Antioxidantes + GABA + Optiberry (mix patentado de Superfrutos:
              Uvas, Blueberries, Amalaki y más).
            </p>
    }]
  }];
  return <section id="productos" className="py-24 bg-[#FAFAF7] overflow-hidden" data-id="element-367">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-368">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-369">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-370">
            Conoce Cada Producto de Tu Sistema
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600" data-id="element-371">
            Cada uno tiene un rol específico para tu transformación
          </motion.p>
        </div>

        <div className="space-y-24 lg:space-y-32" data-id="element-372">
          {products.map((product, index) => {
          const isEven = index % 2 !== 0;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.7
          }} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-20 items-center`} data-id="element-373">
                {/* Image Side */}
                <div className="w-full lg:w-1/2 relative" data-id="element-374">
                  <div className="absolute inset-0 bg-[#4CAF50]/10 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-375"></div>
                  <img src={product.image} alt={product.name} loading="lazy" className="w-full h-auto rounded-3xl shadow-xl object-cover aspect-square lg:aspect-[4/5] border-4 border-white" data-id="element-376" />
                </div>

                {/* Content Side */}
                <div className="w-full lg:w-1/2" data-id="element-377">
                  <div className="inline-block bg-white border border-gray-200 text-[#1B5E20] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide shadow-sm mb-6" data-id="element-378">
                    {product.badge}
                  </div>

                  <h3 className="text-4xl lg:text-5xl font-serif font-bold text-[#1A1A1A] mb-2" data-id="element-379">
                    {product.name}
                  </h3>
                  <p className="text-2xl text-gray-500 font-medium mb-8" data-id="element-380">
                    {product.subtitle}
                  </p>

                  <ProductAccordion tabs={product.tabs} data-id="element-381" />
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}